<template>
  <div class="product-box">
    <div class="product-content">
      <div class="product-top-box">
        <div class="product-top-content">
          <h3>业务经办服务智能内控系统</h3>
          <p>业务人员行为数据，分析完善业务经办行为模型，建立系统行为监控、自动反查监督告警机制，实现完全独立的业务内控智能监管标准体系</p>
        </div>
      </div>
      <div class="product-middle-box">
        <div class="product-middle-content">
          <h3>产品功能</h3>
          <product-list :data="productList"></product-list>
        </div>
      </div>
      <div class="product-middle12-box">
        <div class="product-middle2-content">
          <h3>典型应用场景</h3>
          <product-chang :chang="list"></product-chang>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import productList from "../../components/product/product";
import productChang from "../../components/product/chanjing";
import product11 from "../../assets/image/product11.png";
import product12 from "../../assets/image/product12.png";
import product13 from "../../assets/image/product13.png";
import product21 from "../../assets/image/product21.png";
import product22 from "../../assets/image/product22.png";
import product23 from "../../assets/image/product23.png";
import product24 from "../../assets/image/product24.png";
import product14 from "../../assets/image/product14.png";

// import bg2 from "../../assets/image/home32.png";
export default {
  components: {
    productList,
    productChang,
  },
  data() {
    return {
      productList: [
        {
          name: "01.实时监控",
          path: product11,
          detail: "业务操作全程跟踪监控",
        },
        {
          name: "02.数据获取",
          path: product12,
          detail: "强大的行为数据获取能力",
        },
        {
          name: "03.智能分析",
          path: product13,
          detail: "深入的行为数据分析，构建行为模型",
        },
        {
          name: "04.行为可视化",
          path: product14,
          detail: "多维度行为数据分析后做数据可视化",
        },
      ],
      list: [
        {
          name: "01.业务经办强管控",
          path: product21,
          detail:
            "操作行为全程记录监控，获取行为数据，分析和构建业务经办数据模型，实现事前监督、事中告警、事后追溯。",
        },
        {
          name: "02.人员绩效考核新方式",
          path: product22,
          detail:
            "全流程可视化人员业务经办工作量、工作时长、工作效率提供和分析人员绩效考核数据和依据，支持新的考核制度和方式。",
        },
        {
          name: "03.业务培训优教程",
          path: product23,
          detail:
            "精准的业务经办模型标准化业务经办流程、处理方式、处理结果以及明确业务经办重点和要点，支持更精准全面的培训教程和方式，辅助提高业务人员专业度。",
        },
        {
          name: "04.业务操作快告警",
          path: product24,
          detail:
            "利用智能算法，捕捉敏感业务经办行为，结合智能行为数据模型，预测风险行为，提前给出告警消息，使业务经办更安全稳定。",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.product-box {
  width: 100%;
  .product-content {
    width: 100%;
    .product-top-box {
      width: 100%;
      padding-top: 153px;
      height: 450px;
      background: url("../../assets/image/productbg.png") no-repeat;
      background-size: cover;
      -webkit-background-size: cover;
      -o-background-size: cover;
      background-position: center 0;
      .product-top-content {
        width: 1200px;
        margin: 0 auto;
        h3 {
          font-size: 50px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        p {
          width: 629px;
          height: 48px;
          font-size: 18px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 30px;
        }
      }
    }
    .product-middle-box {
      width: 100%;
      height: 502px;
      .product-middle-content {
        width: 1200px;
        margin: 0 auto;
        h3 {
          width: 100%;
          margin: 59px 0 64px;
          font-size: 28px;
          font-weight: 500;
          text-align: center;
          color: rgba(6, 10, 34, 1);
        }
      }
    }
    .product-middle12-box {
      width: 100%;
      height: 700px;
      background: rgba(248, 249, 251, 1);
      .product-middle2-content {
        width: 1200px;
        height: 700px;
        margin: 0 auto;
        background: url("../../assets/image/product2bg.png") no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        h3 {
          padding-top: 58px;
          margin-bottom: 100px;
          font-size: 28px;
          text-align: center;
          font-weight: 500;
          color: rgba(6, 10, 34, 1);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/index.vue